import React from "react";
import Loader from "../Loader";
import RoomCardSkeleton from "./RoomCardSkeleton";

function RoomSkeleton({ isAppPage = false }) {
  return (
    <div className="sm:absolute w-full -mx-0 sm:-mx-12">
      <div className=" w-full animate-pulse bg-frescoWhite dark:bg-darkGray  md:h-64 h-56 "></div>
      <div className="relative px-0 md:px-12">
        <div className="bg-transparent flex md:flex-row flex-col items-center  justify-between mt-9  space-y-3 md:space-y-0">
          <div className="flex flex-col space-y-3">
            <p className="rounded-xl animate-pulse bg-frescoWhite dark:bg-darkGray w-36 h-6 "></p>
          </div>
          <div className="gap-y-3 space-x-3 items-center justify-center inline-flex flex-wrap">
            <div className="rounded-full w-9 animate-pulse bg-frescoWhite dark:bg-darkGray h-9"></div>
            <div className="rounded-full w-9 animate-pulse bg-frescoWhite dark:bg-darkGray h-9"></div>
            <div className="rounded-full w-9 animate-pulse bg-frescoWhite dark:bg-darkGray h-9"></div>
            <div className="rounded-3xl w-28 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
            <div className="rounded-3xl w-24 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
          </div>
        </div>
        <div className="rounded-2xl w-28 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
        <div className="mt-6 animate-pulse bg-grayLighter dark:bg-gray-600 w-full   h-px" />
        {isAppPage ? (
          <div className="mt-6">
            <p className="rounded-xl animate-pulse bg-frescoWhite dark:bg-darkGray w-36 h-8 "></p>
            <RoomCardSkeleton totalCard={12} showMenu={false} />
          </div>
        ) : (
          <div className="mt-24">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
}

export default RoomSkeleton;
